import { reactive } from "vue";

export function useSnackbar() {
  const snackbarSettings = reactive({
    show: false,
    message: "",
    color: "success",
    timer: 3000,
  });

  const updateSnackbarSettings = (settings) => {
    if (typeof settings !== "undefined") {
      const includedKeys = Object.keys(snackbarSettings);

      const keys = Object.keys(settings);

      for (let i in keys) {
        let property = keys[i];

        if (includedKeys.includes(property)) {
          snackbarSettings[property] = settings[property];
        }
      }
    }
  };

  return { snackbarSettings, updateSnackbarSettings };
}
